import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

function getInitialEditorState(content) {
  if (!content) {
    return EditorState.createEmpty();
  }
  if (Object.keys(content).length === 0 && content.constructor === Object) {
    return EditorState.createEmpty();
  }
  return EditorState.createWithContent(convertFromRaw(content));
}

class TextEditor extends React.Component {
  constructor(props) {
    super(props);
    props.input.value=''
    const editorState = getInitialEditorState(props.input.value);

    this.state = {
      editorState,
      pristine: true,
    };
  }
  onEditorStateChange: Function = editorState => {
    this.setState({
      editorState,
      pristine: false,
    });
    this.props.input.onChange(convertToRaw(editorState.getCurrentContent()));
  };

  render() {
    const { editorState } = this.state;
    return (
      <FormGroup>
        <ControlLabel>{this.props.label}</ControlLabel>
        <Editor
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          toolbar={{
            options: ['inline', 'blockType', 'list', 'textAlign', 'history'],
            inline: {
              options: ['bold', 'italic', 'underline'],
            },
            blockType: {
              options: ['Normal', 'H1', 'H2'],
              className: 'fontSizeDrop',
            },
            textAlign: {
              options: ['left', 'center', 'right'],
            },
          }}
          onEditorStateChange={this.onEditorStateChange}
        />
      </FormGroup>
    );
  }
}
TextEditor.propTypes = {
  input: PropTypes.object.isRequired,
};

export default TextEditor;



// WEBPACK FOOTER //
// src/routes/tours/components/TextEditor.js